module.exports = __webpack_public_path__ + "static/img/stop-surveillance.3dbc32b8.svg";